import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation, ElementRef,AfterViewInit} from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { ConfirmModalPopupModel } from 'lib/ng2-sapmp/src/ui-components/confirm-modal';
// import { ReportSuccessPopup } from './report-success-popup.html';
import { DomSanitizer } from '@angular/platform-browser';
import { UtilityService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { FormsModule } from '@angular/forms';
import { ReportService } from './shared/';
import { Router, ActivatedRoute } from '@angular/router';
import { UserProfileModel } from 'lib/ng2-sapmp/src/models';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
import { KEY_CONFIG } from 'lib/ng2-sapmp/src/config/key-config';

export class Fan {
  constructor(public id: number, public name: string) { }
}

@Component({
  selector: 'app-report',
  providers: [ReportService],
  templateUrl: './report-request.component.html',
  styleUrls: ['./report-request.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReportRequestComponent implements OnInit, AfterViewInit {
  overviewModalPopup: ConfirmModalPopupModel;
  modalClass: string;
  ReportPopup: any;
  trustedReportPopup: any;
  showOverviewModal: boolean;
  showSuccess: boolean;
  showError: boolean;
  public FanLists: Array<Fan>;
  showNew = false;
  showNewMI = false;


  @Input()
  modalPopupObject: ConfirmModalPopupModel;
  @Input() triggerElement: any;

  @Output()
  modalOutput: EventEmitter<boolean>;

  focusableElements: any;
  report: any;
  userInfo: any;
  userEmail: String;
  companyId: number;
   fanList: any;
  url: String;
  public allFans: Array<any>;
  constructor(private el: ElementRef, private parentRouter: Router,
    private route: ActivatedRoute, private utilityService: UtilityService, private adobeAnalyticsService: AdobeAnalyticsService,
    private reportService: ReportService,
    private pageloaderService: PageLoaderService) {
    this.showError = false;
    this.modalOutput = new EventEmitter<boolean>();
    this.overviewModalPopup = new ConfirmModalPopupModel();
    this.showSuccess = false;
    const democompany = sessionStorage.getItem('democompany');
    this.companyId = democompany ? parseInt(democompany) : 1;
    sessionStorage.setItem('dontShowAllFanRabioButton', 'false');
    this.FanLists = [];
    this.getFANList();
    if(this.showNew || this.showNewMI){
    this.report = {
      format: '',
      type: 'Device status'
    }
  }else{
    this.report = {
      format: '',
      type: ''
    }
  }
  }

  ngOnInit() {
    console.log('inside report page');
    this.showOverviewModal = true;
    document.body.classList.add('modal-open');
    let mdmData =JSON.parse(sessionStorage.getItem("mdmDetails")) ;
    if(window.location.pathname == "/businessconsole/manageInventory/deviceInventory" && (mdmData.productCode =="ADDPZTE" ) || (mdmData.productCode =="DMPAABM" )) {
      this.showNew=true;
    }else if(window.location.pathname == "/businessconsole/manageInventory" && (mdmData.productCode =="ADDPZTE" )) {
      this.showNewMI=true;
    }
  }

  ngAfterViewInit(){
    this.el.nativeElement.focus();
    if(document.getElementById('modalHeading') != null){
      document.getElementById('modalHeading').focus();
    }
    }

    setFocus(element,event?){
      if(element === 'report-request-btn' && document.getElementById(element) != null){
        if(event.keyCode !== 37 && event.keyCode !== 38 && event.keyCode !== KEY_CONFIG.enter && event.keyCode !== KEY_CONFIG.space){
          document.getElementById(element).focus();
          event.preventDefault();
          event.stopPropagation();
        }

        if(event.keyCode === 9 && !this.report.format){
          document.getElementById('closeBtn').focus();
        }

      }else if(document.getElementById(element) != null){
        document.getElementById(element).focus();
      }

    }

  btnAction(value,event?) {

    if (!event || event.keyCode === KEY_CONFIG.enter || event.keyCode === KEY_CONFIG.space) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

    if(this.showNew || this.showNewMI){
    this.reportService.setRequestObject({ type: 'Device status', format: this.report.format });
    }else{
      this.reportService.setRequestObject({ type: this.report.type, format: this.report.format }); 
    }
    const impersonator = JSON.parse(sessionStorage.getItem('impersonator'));
    const isDisabled = impersonator && impersonator.id ? true : false;
    if (isDisabled) {
      (<HTMLInputElement>document.getElementById('report-request-btn')).disabled = true;
    } else {
    if (this.report.type === 'Transaction history') {
      this.showOverviewModal = false;
      this.parentRouter.navigateByUrl('/reports/transaction');
      this.closeModalPopup(false);
    } else {
      const userInfo = sessionStorage.getItem('user');
      const user = JSON.parse(userInfo);
      const userEmail = user.user.emailAddress;
      const userName = user.user.firstName + ' ' + user.user.lastName;
      const format = this.report.format === 'PDF' ? 'PDF' : 'XLS';
	  let fan = sessionStorage.getItem('selectedFAN');
      console.log('selected fan');
    let devicesSummary = JSON.parse(sessionStorage.getItem("devicesSummary"));
    let activeDevices = devicesSummary.filter(x=>x.fan.status === "ACTIVE" );
    let activeDevicesFan =[];
    for(let i = 0 ; i < activeDevices.length ; i++) {
      if(activeDevices[i].fan.fanId === fan){
        activeDevicesFan.push(activeDevices[i])
      }
    }

    activeDevices = activeDevicesFan;

    let emmProduct = '';
    let emmProductArr = [];
    if (activeDevices && activeDevices.length > 0) {
      activeDevices.map(function (item) {
        emmProduct = item.fan.emmProductCode + "_" + item.fan.emmAccountId;
        emmProductArr.push(emmProduct);
      });
    }

    if (emmProductArr && emmProductArr.length > 0) {
      emmProductArr = emmProductArr.filter(
        (item, index) => emmProductArr.indexOf(item) === index
      );
    }

    let emmProductString = emmProductArr.map((item,index)=>'emm'+(index+1)+'='+item).join('&');

      if(this.showNew){
    this.url = this.utilityService.getEnvConfig().getReportRequestOEMUrl
      + '?' + 'type=' + format + '&email=' + userEmail + '&username=' + userName +'&fan=' +fan +'&'+emmProductString;
    }else if(this.showNewMI){
      this.url = this.utilityService.getEnvConfig().getReportRequestUrl
      + '?' + 'type=' + format + '&email=' + userEmail + '&username=' + userName; 
    }else{
      this.url = this.utilityService.getEnvConfig().getReportRequestUrl
      + '?' + 'type=' + format + '&email=' + userEmail + '&username=' + userName;
    }
      this.pageloaderService.setPageLoaderStatus(false);
      this.reportService.doRequestReport(this.url)
        .subscribe(respobj => {
          this.pageloaderService.setPageLoaderStatus(true);
          if (respobj.message === 'True' ) {
            this.showOverviewModal = false;
            this.showSuccess = true;
            this.adobeAnalyticsService.trackPageProperties(); // TEMP URL Fix
          }else {
            this.showOverviewModal = true;
            this.showError = true;
          }
        }, error => {
          this.pageloaderService.setPageLoaderStatus(true);
          this.handleError(error);
        });
    }
  }
 }
}

  loadFocuselements() {
    if (!this.focusableElements) {
      const focusableEls = this.utilityService.getFocusableElements(this.el);
      this.focusableElements = Array.prototype.slice.call(focusableEls);
      // this.focusableElements[0].focus();
      if(document.getElementById('modalHeading') != null){
        document.getElementById('modalHeading').focus();
      }     
    }
  }
  handleKeydown(event) {
    if (event.keyCode === KEY_CONFIG.escapeKey) {
      this.closeModalPopup(false);
      return;
    }
    this.utilityService.handleKeyPress(event, this.focusableElements);
  }

  closeModalPopup(value,event?) {
    // this.showOverviewModal = false;
    // document.body.classList.remove('modal-open');
    // this.modalOutput.emit(value);
    // this.focusableElements = undefined;
    //   if (this.triggerElement) {
    //     this.triggerElement.focus();
    //   } else {
    //     this.focusableElements = undefined;
    //     if (this.triggerElement) {
    //       this.triggerElement.focus();
    //     }
    //   }

    if (!event || event.keyCode === KEY_CONFIG.enter || event.keyCode === KEY_CONFIG.space) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      document.body.classList.remove('modal-open');
      // this.modalOutput.emit(value);
      this.focusableElements = undefined;
      if (this.triggerElement) {
        this.triggerElement.focus();
      }
      this.modalOutput.emit(value);
    }
  }

  getFANList() {
    this.pageloaderService.setPageLoaderStatus(false);
    let respobj = JSON.parse(sessionStorage.getItem('summaryData'));
    // this.reportService.getFANList()
    //   .subscribe(respobj => {
        this.pageloaderService.setPageLoaderStatus(true);
        this.allFans = respobj.revisedFanList;
         if (this.allFans.length === 1) {
          sessionStorage.setItem('dontShowAllFanRadioButton', 'true');
        }
        this.allFans.forEach((item, index) => {
          this.FanLists.push(new Fan(index + 1, item.fanId));
        });
        sessionStorage.setItem('FanLists', JSON.stringify(this.FanLists));

    // }, error => {
    //    this.handleError(error);
    // });
  }

  handleError(error) {
    this.showOverviewModal = true;
    this.showError = true;
  }

  
}
